export const scrollConfig = Object.freeze({
    globalScrollYOffset: 200
});
